
import { Art } from "@/utils/dto/art.js"
import ObjectSnippet from "@/components/objects/ObjectSnippet.vue";
import ShareLinks from "@/components/objects/public/ShareLinks.vue";
import AboutAuthor from "@/components/AboutAuthor.vue";
import CommentsBlockComponent from "@/components/art/public/CommentsBlockComponent.vue";
import { STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { trackHit } from "@/utils/helpers.js";
import ScoringModal from "@/components/objects/ScoringModal.vue";
import Subscribes from "@/components/objects/public/Subscribes.vue";
import DonateBlock from "@/components/objects/public/DonateBlock.vue";
import UserPublicAvatar from '@/components/users/UserPublicAvatar.vue'
import LinkedObjectPublic from "@/components/LinkedObjectPublic.vue";

export default {
  name: "ArtDetail",
  components: { ObjectSnippet, ShareLinks, CommentsBlockComponent, ScoringModal, AboutAuthor, Subscribes, DonateBlock, UserPublicAvatar, LinkedObjectPublic },
  provide () {
    return {
      specialProject: false
    }
  },
  layout: "public_new",
  meta: {
    pageLayoutBg: '#ffffff',
  },
  async asyncData({ params, store, error, redirect, $axios }) {
    const [artData, latest] = await Promise.allSettled(
      [
        store.dispatch('art/publicObject', params['slug']),
        store.dispatch('art/asideObjects', {
          id: params['slug'],
          params: {
            offset: 0,
            limit: 5,
            is_about_project: false,
          },
        })
      ]
    )

    // if (artData.status === 'rejected') {
    if (artData.status === 'rejected' || !artData.value) {
      return error({ statusCode: 404, humanReadableMessage: 'У нас нет такого материала. Но вы можете его создать!' })
    }

    if (params['slug'] !== artData.value.slug) {
      return redirect(`/art/${artData.value.slug}`);
    }

    if (artData.value.is_spec_project) {
      return redirect(`/sp/${artData.value.slug}`);
    }

    let comments = []
    if (artData.value.is_comments_enabled) {
      await $axios.get(`${process.env.BASE_URL_V2}/public/comments/?obj_cls=materials&obj_id=${artData.value.id}`).then((response) => {
        if (response?.status === 200 && response?.data) {
          comments = response.data
        }
      })
    }

    return {
      comments,
      artData: artData.value,
      latestMaterials: latest.value,
      materialCategories: await store.dispatch('art/fetchMaterialCategories')
    }
  },
  data() {
    return {
      /** @type Art */
      object: {
        blocks: [],
        label: '',
        // is_comments_enabled: true,
        user: {
          id: '',
          profile: {
            about: '',
            icon: '',
            nickname: '',
            telegram_url: '',
            vk_url: ''
          },
          username: ''
        }
      },
      artData: {},
      latestMaterials: [],
      comments: [],
      imagePath: [`${STORAGE_IMAGE_PATH}$id`, 'cover'],
      registerViewPromise: null,
      scrollToCommentsPromise: null
    }
  },

  head() {
    return {
      title: this.headTitle,
      meta: [
        { hid: 'description', name: 'description', content: this.headDescription },
        { hid: 'og:title', property: 'og:title', content: this.headTitle + '.' },
        { hid: 'og:image', property: 'og:image', content: this.headImage },
        { hid: 'og:type', property: 'og:type', content: 'article' },
        { hid: 'og:description', property: 'og:description', content: this.headDescription },
        { hid: 'og:site_name', property: 'og:site_name', content: 'ViStat.ORG - Интерактивная инфографика.' },
      ],
    }
  },
  computed: {
    isStaging() {
      return process.env.isStaging
    },
    updatedAt() {
      const date = new Date(this.artData.updated_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `${day}.${month}.${date.getFullYear()}`
    },
    createdAt() {
      const date = new Date(this.artData.created_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `${day}.${month}.${date.getFullYear()}`
    },
    headTitle() {
      let title = this.object.label
      return title

    },
    headDescription() {
      let text = ''
      const blockWithText = this.artData.blocks.find(block => block.text)
      if (this.artData.sublabel) {
        const sublabel = this.artData.sublabel.split('.')
        text += `${sublabel[0]}. `
        text += sublabel[1] ? sublabel[1] : ''
      }
      if (blockWithText) {
        text += blockWithText.text.split('.')[0]
      }
      return text.replace(/[&\/\\#+()$~%'":*?<>{}\<p\>]/g, '') + '.'
    },
    headImage() {
      const blockWithImg = this.artData.blocks.find(block => block.type === 'image' && block.image)
      return blockWithImg ? this.$addServerPath(this.imagePath[0].replace('$id', blockWithImg.image.image_file)) : ''
    }
  },
  created() {
    this.object = new Art(this.artData, this.$store)
  },
  mounted() {
    // this.object = new Art(this.artData, this.$store);
    trackHit(this.$route.fullPath, this.headTitle, this.$route.meta.referer)

    if (document.getElementById('comments') && this.$route.hash === '#comments') {
      this.scrollToCommentsPromise = setTimeout(() => {
        document.getElementById('comments').scrollIntoView({ block: "nearest", behavior: "smooth" });
      }, 200)
    }
    this.registerViewPromise = setTimeout(() => {
      this.$store.dispatch('art/registerView', this.$route.params.slug)
    }, 3000)
  },
  beforeDestroy() {
    if (this.registerViewPromise) clearTimeout(this.registerViewPromise)
    this.registerViewPromise = null
    if (this.scrollToCommentsPromise) clearTimeout(this.scrollToCommentsPromise)
    this.scrollToCommentsPromise = null
  },
  methods: {
    showScoring() {
      this.$vfm.show({
        component: ScoringModal,
        bind: {
          label: this.object.label,
          scoring_data: this.object.scoring_data,
          score: this.object.scoring_score ?? '-',
          total_score: this.object.total_score ?? '-',
        }
      })
    }
  },
}
